import React from 'react'
import styles from './bookSummary.module.css'
import BookSummaryService from "./BookSummaryService"
import { formatDuration, formatPrice } from '../../../utils/pricing'

function BookSummary({
    selectedServices = [],
    onScheduleClick = () => {},
    onRemoveService = () => {},
    onEditService = () => {},
}) {
    const totalPrice = selectedServices.reduce((sum, service) => sum + (Number(service.total_price) || 0), 0);
    const totalDuration = selectedServices.reduce((sum, service) => sum + (Number(service.total_duration) || 0), 0);

    return (
        <div className={styles.summary}>
            <h1 className={styles.summaryTitle}>Appointment Summary</h1>
            {selectedServices.length === 0 ? (
                <p className={styles.serviceEmpty}>No services selected.</p>
                ):(
                    <div className={styles.serviceList}>
                        {selectedServices.map((service, index) => (
                            <BookSummaryService 
                                key={index} 
                                service={service}
                                onRemoveService={() => onRemoveService(service)}
                                onEditService={() => onEditService(service)}
                            />
                        ))}
                    </div>
                )
            }
            <div className={styles.summaryFooter}>
                {selectedServices.length > 0 && (
                    <div className={styles.totals}>
                        <div className={styles.totalsLabel}>
                            <span>Total</span>
                            <span className={styles.totalsMeta}>
                                {selectedServices.length} {selectedServices.length === 1 ? 'service' : 'services'} · {formatDuration(totalDuration)}
                            </span>
                        </div>
                        <span className={styles.totalsPrice}>{formatPrice(totalPrice)}</span>
                    </div>
                )}

                <button 
                    onClick={onScheduleClick} 
                    disabled={selectedServices.length === 0} 
                    className={styles.scheduleButton}
                >
                    Schedule Appointment
                </button>
            </div>
        </div>
    )
}

export default BookSummary
